import { v4 as UUID } from 'uuid'
import { LayoutConfig } from 'golden-layout'

import bareLayout from './json-files/golden-layout-state/bare-layout-config.json'
import { Workspace } from '@helios/state-management'

/**
 * Preset Workspace from scratch (has nothing but getting started page)
 * Keeping this around as a backup if somehow the basic recon preset gets deleted in the backend
 *
 * @internal
 */
export const BARE_WORKSPACE: Workspace = {
  workspaceId: UUID(),
  workspacePrefix: '',
  name: 'Bare',
  description: 'This workspace only contains the Getting Started panel.',
  workspace: bareLayout as unknown as LayoutConfig,
}
